import React, { Component } from 'react'
import '../styles/PopInExpiration.css'
import PopIn from './PopIn'
import { injectIntl, defineMessages } from "react-intl"

class PopInConfirmation extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="popin-expiration popin-confirmation">
        <PopIn
          closePopIn={() => this.props.closePopIn()}
        >
          <h3>{formatMessage(messages.title)}</h3>
          <p>{formatMessage(messages.info)}</p>
          <div onClick={() => this.props.closePopIn()} className="popin-expiration-cta">{formatMessage(messages.cta)}</div>
        </PopIn>
      </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'popInConfirmation.title',
    defaultMessage: 'Merci !'
  },
  info: {
    id: 'popInConfirmation.info',
    defaultMessage: 'Nous avons bien reçu votre demande devis.'
  },
  cta: {
    id: 'popInConfirmation.cta',
    defaultMessage: 'OK !'
  }
})

export default injectIntl(PopInConfirmation)



// WEBPACK FOOTER //
// ./src/components/PopInConfirmation.js